import * as Hooks from 'preact/hooks';
import { useDispatch } from '../store/redux';
import * as Actions from '../store/actions/app';

export const useExploreLoading = (partsLoading: boolean) => {
    const [initialLoad, setInitialLoad] = Hooks.useState(true);
    const [dispatchedReadyAction, setDispatchedReadyAction] = Hooks.useState(false);
    const dispatch = useDispatch();

    Hooks.useEffect(() => {
        // TODO: use model loading status as well
        if (initialLoad === true && partsLoading === false) {
            setInitialLoad(false);
            if (!dispatchedReadyAction) {
                // Used to track initial load time, we don't want it to trigger again when entering Configuration
                dispatch(Actions.loadingFinishedAction());
                setDispatchedReadyAction(true);
            }
        }
    }, [partsLoading]);

    const resetInitialLoad = Hooks.useCallback(() => {
        setInitialLoad(true);
    }, []);

    return { initialLoad, resetInitialLoad };
};
